module.exports = __webpack_public_path__ + "static/media/details-30-image-4.3c62d8b6.jpg";